export default "__VITE_ASSET__1014fe06__"